import React from 'react';
import StatusButton from '../../../components/StatusButton';

export default function ElementStatusV2StatusCell({
  onRefreshRow = () => {},
  row,
}) {
  const onChangeStatus = () => onRefreshRow(row.personId, row.elementId);
  const containerStyle = {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    padding: 0,
    width: '100%',
  };
  return (
    <div className="status-table__status-cell-actions" style={containerStyle}>
      <StatusButton
        areaId={row.moduleId || row.raw?.moduleId}
        daysUntilExpiration={row.daysUntilExpiration || 0}
        elementId={row.elementId}
        elementName={row.elementName}
        hasHistory={Boolean(row.hasHistory)}
        hasValidity={Boolean(row.hasValidity)}
        mediatorId={row.responsibleId || row.raw?.responsibleId || ''}
        nextAction={row.nextAction || ''}
        onChangeStatus={onChangeStatus}
        pending={row.pending || 'None'}
        personId={row.personId}
        personName={row.personName}
        size="md"
        status={row.status || 'NoCompletion'}
      />
    </div>
  );
}
